import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ConceptsOpenService } from '@shared/factories/concepts-open/concepts-open.service';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';

@Injectable({
  providedIn: 'root'
})

export class ConceptResolver  {
    constructor(private apiService: ApiServiceService,
      private conceptsOpenService: ConceptsOpenService
    ) {}
    resolve(route: ActivatedRouteSnapshot) {
      return this.apiService.get('concepts', route.params['evaluationId']+'/'+route.params['conceptId'])
        .then((data:any)=>{
          this.conceptsOpenService.deleteAllConceptsOpen();
          return data
        })
    }
}
